import { useContext } from "react";
import { ShowContent } from "../../../components";
import AuthContext from "../../../context/AuthContext";
import ChemicalTrackerClient from "./ChemicalTrackerClient";
import ChemicalTrackerAdmin from "./ChemicalTrackerAdmin";

export const ChemicalTrackerPage = () => {
  const { isClient, isLoading } = useContext(AuthContext);

  let content: JSX.Element | JSX.Element[];
  if (isClient) {
    content = <ChemicalTrackerClient />;
  } else {
    content = <ChemicalTrackerAdmin />;
  }

  return <ShowContent error={""} isLoading={isLoading} content={content} />;
};
